module.exports = "/_next/static/images/Rectangle 2-589585a749da00f443a618d7efdd8955.png";